
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import UserRepositoryAPI from "@/modules/user/user-repository-api";
import { location } from "@/utils/default-data";
export default defineComponent({
  setup() {
    const { t } = useI18n();
    const { getUser } = UserRepositoryAPI();
    return {
      t,
      location,
      getUser,
    };
  },
});
